import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Eye } from 'lucide-react';
import { LevelBadge } from './StudentBadges';

export const StudentOverview = ({ mastery, history, setTab }) => (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {/* Quick mastery summary */}
          <Card className="bg-card border-border" data-testid="overview-mastery">
            <CardHeader className="pb-2"><CardTitle className="text-base">Maîtrise par notion</CardTitle></CardHeader>
            <CardContent>
              {mastery.length > 0 ? (
                <div className="space-y-2">
                  {mastery.slice(0, 8).map(m => (
                    <div key={m.notion_id} className="flex items-center justify-between gap-2">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm truncate">{m.notion_label}</p>
                        <p className="text-xs text-muted-foreground truncate">{m.theme} › {m.chapter}</p>
                      </div>
                      <div className="flex items-center gap-2 shrink-0">
                        <div className="w-24 h-2 bg-muted rounded-full overflow-hidden">
                          <div className={`h-full rounded-full ${m.score >= 75 ? 'bg-emerald-400' : m.score >= 50 ? 'bg-blue-400' : 'bg-red-400'}`} style={{ width: `${Math.min(m.score || 0, 100)}%` }} />
                        </div>
                        <LevelBadge value={m.score} />
                      </div>
                    </div>
                  ))}
                  {mastery.length > 8 && <button onClick={() => setTab('mastery')} className="text-xs text-primary hover:underline mt-1">Voir toutes les {mastery.length} notions</button>}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground text-center py-6">Aucune notion taguée.</p>
              )}
            </CardContent>
          </Card>

          {/* Recent quiz history */}
          <Card className="bg-card border-border" data-testid="overview-history">
            <CardHeader className="pb-2"><CardTitle className="text-base">Derniers QCM</CardTitle></CardHeader>
            <CardContent>
              {history.length > 0 ? (
                <div className="space-y-2">
                  {history.slice(0, 5).map(h => (
                    <div key={h.result_id} className="flex items-center justify-between gap-3 p-2 rounded-lg bg-muted/20">
                      <div className="flex-1 min-w-0">
                        <p className="text-sm font-medium truncate">{h.quiz_title}</p>
                        <p className="text-xs text-muted-foreground">{h.date ? new Date(h.date).toLocaleDateString('fr-FR') : '—'}</p>
                      </div>
                      <div className="flex items-center gap-3 shrink-0">
                        <div className="text-right">
                          <LevelBadge value={h.student_score} />
                          {h.diff_from_median != null && (
                            <p className={`text-xs ${h.diff_from_median >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>
                              {h.diff_from_median >= 0 ? '+' : ''}{h.diff_from_median} vs classe
                            </p>
                          )}
                        </div>
                        {h.result_id && (
                          <Link to={`/results?quiz=${h.quiz_id}`}>
                            <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-primary" data-testid={`view-quiz-${h.result_id}`}><Eye className="w-3.5 h-3.5" /></Button>
                          </Link>
                        )}
                      </div>
                    </div>
                  ))}
                  {history.length > 5 && <button onClick={() => setTab('history')} className="text-xs text-primary hover:underline mt-1">Voir les {history.length} QCM</button>}
                </div>
              ) : (
                <p className="text-sm text-muted-foreground text-center py-6">Aucun QCM passé.</p>
              )}
            </CardContent>
          </Card>
        </div>
);
